import {
  AlreadyRented,
  NoChargersAvailable,
  PreAuthFailed,
  Recharging,
  StationOffline,
} from '~assets/icons/station-status';
import { IssueEjectingImage } from '~assets/icons/station-status/IssueEjectingImage';
import { MessageInfo } from '~types/common.type';
import { StationStatus } from '~types/station.type';

export const stationStatusMessages: Record<StationStatus, MessageInfo> = {
  [StationStatus.OFFLINE]: {
    localeTextId: 'app.badStatusStationPage.text.stationStatus.online',
    title: 'Station is Currently Offline',
    img: StationOffline,
  },
  [StationStatus.RECHARGING]: {
    localeTextId: 'app.badStatusStationPage.text.stationStatus.recharging',
    title: 'Chargers are Recharging',
    img: Recharging,
  },
  [StationStatus.NO_CHARGERS_AVAILABLE]: {
    localeTextId:
      'app.badStatusStationPage.text.stationStatus.noChargersAvailable',
    title: 'No Chargers Available',
    img: NoChargersAvailable,
  },
  [StationStatus.ALREADY_RENTED]: {
    localeTextId: 'app.badStatusStationPage.text.stationStatus.alreadyRented',
    title: 'You are Currently Renting',
    img: AlreadyRented,
  },
  [StationStatus.PRE_AUTH_FAILED]: {
    localeTextId: 'app.badStatusStationPage.text.stationStatus.preAuthFailed',
    title: 'Payment Declined',
    img: PreAuthFailed,
  },
  [StationStatus.ISSUE_EJECTING]: {
    localeTextId: 'app.badStatusStationPage.text.stationStatus.issueEjecting',
    title: 'Issue Ejecting Charger',
    img: IssueEjectingImage,
  },
};
